import React, { useState } from 'react';

// hooks
import useMobileViewport from 'hooks/useMobileViewport';

// utils
import { tabletMinWidth } from 'utils/layout.utils';

// styles
import './chartCombo.scss';

interface ChartComboProps {
    label: string;
    itemPrefix?: string;
    selectedItem: ChartComboItem;
    options: Array<ChartComboItem>;
    onChange: (value: ChartComboItem) => void;
    mode: 'combo' | 'buttons';
}

export interface ChartComboItem {
    value: string;
    text: string;
}

const ChartCombo = (props: ChartComboProps) => {
    const [open, setOpen] = useState<boolean>(false);

    const handleToggleVisibility = () => {
        setOpen(!open);
    };

    const handleFilterClick = (value: ChartComboItem) => {
        props.onChange(value);
        setOpen(false);
    };

    return (
        <div className={`chartcombo chartcombo-${props.mode} ${open ? 'open' : ''}`}>
            <label className="chartfilter-label">{props.label}</label>
            <div className="chartcombo-selected" onClick={handleToggleVisibility}>
                {props.itemPrefix ? props.itemPrefix + ' ' : ''}
                {props.selectedItem.text}
                <div className="chartcombo-selected-arrow "></div>
            </div>
            <div className="chartcombo-options">
                <ul>
                    {props.options.map((item, index) => (
                        <li key={item.value + index.toString()} className={props.selectedItem.value === item.value ? 'd-none d-md-inline-block' : ''}>
                            <button
                                className={`chartcombo-option-btn ${props.selectedItem.value === item.value ? 'active' : ''}`}
                                onClick={() => handleFilterClick(item)}
                            >
                                {props.itemPrefix ? props.itemPrefix + ' ' : ''}
                                {item.text}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

ChartCombo.defaultProps = {
    itemPrefix: '',
};

export default ChartCombo;
